/**
 * iOS Safari helpers — touch release timing and viewport differ from Android.
 */

let cachedIOSSafari = null;

export function isIOSSafari() {
  if (cachedIOSSafari !== null) return cachedIOSSafari;
  if (typeof navigator === "undefined") {
    cachedIOSSafari = false;
    return false;
  }
  const ua = navigator.userAgent || "";
  const iOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const webkit = /WebKit/i.test(ua);
  const notOtherBrowser = !/CriOS|FxiOS|EdgiOS|OPiOS|Chrome\/\d+/i.test(ua);
  cachedIOSSafari = iOS && webkit && notOtherBrowser;
  return cachedIOSSafari;
}

/** Layout height — accounts for iOS Safari dynamic toolbar. */
export function getMobileViewportHeight() {
  return window.visualViewport?.height ?? window.innerHeight ?? 800;
}

/**
 * Run after finger lift once WebKit has applied scroll/layout (IO needs this).
 * @param {() => void} fn
 */
export function afterTouchRelease(fn) {
  if (isIOSSafari()) {
    requestAnimationFrame(() => {
      requestAnimationFrame(fn);
    });
    return;
  }
  requestAnimationFrame(fn);
}
